export interface ChildNavItem {
  icon: string;
  labelKey: string;
  route: string;
  exact?: boolean;
}

export interface NavItem {
  icon: string;
  labelKey: string;
  route?: string;
  exact?: boolean;
  children?: ChildNavItem[];
}

export const NAV_ITEMS: NavItem[] = [
  { icon: 'tabler:layout-dashboard', labelKey: 'sidebar.dashboard', route: '/', exact: true },
  { icon: 'tabler:building-warehouse', labelKey: 'sidebar.warehouse',      route: '/warehouse'      },
  { icon: 'tabler:recycle',            labelKey: 'sidebar.waste',         route: '/waste'          },
  { icon: 'tabler:flask',              labelKey: 'sidebar.chemicals',     route: '/chemicals'      },
  { icon: 'tabler:file-text',          labelKey: 'sidebar.documentation', route: '/documentation'  },
  { icon: 'tabler:report-analytics',  labelKey: 'sidebar.reports',       route: '/reports'         },
  {
    icon: 'tabler:settings',
    labelKey: 'sidebar.administration',
    children: [
      { icon: 'tabler:hierarchy', labelKey: 'sidebar.orgStructure', route: '/admin/org-structure' },
      { icon: 'tabler:id', labelKey: 'sidebar.operators', route: '/admin/users/collaborators' },
      { icon: 'tabler:user-shield', labelKey: 'sidebar.internalUsers', route: '/admin/users/internal' },
      { icon: 'tabler:list-details', labelKey: 'sidebar.wasteCodes', route: '/admin/waste-codes' },
    ],
  },
];
